import {
  ANALYTICAL_ACCOUNTS_LIST,
  ANALYTICAL_ACCOUNTS_LIST_SUCCESS,
  ANALYTICAL_ACCOUNTS_LIST_ERROR,
  ANALYTICAL_ACCOUNTS_NEW,
  ANALYTICAL_ACCOUNTS_NEW_SUCCESS,
  ANALYTICAL_ACCOUNTS_NEW_ERROR,
  ANALYTICAL_ACCOUNTS_EDIT,
  ANALYTICAL_ACCOUNTS_DELETE,
  ANALYTICAL_ACCOUNTS_DELETE_SUCCESS,
  ANALYTICAL_ACCOUNTS_DELETE_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseNew: "",
  loadingNew: false,
  errorNew: "",
  responseDelete: "",
  loadingDelete: false,
  errorDelete: "",
}

const AnalyticalAccounts = (state = initialState, action) => {
  switch (action.type) {
    case ANALYTICAL_ACCOUNTS_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case ANALYTICAL_ACCOUNTS_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case ANALYTICAL_ACCOUNTS_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case ANALYTICAL_ACCOUNTS_NEW:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case ANALYTICAL_ACCOUNTS_NEW_SUCCESS:
      state = {
        ...state,
        loadingNew: false,
        responseNew: action.payload.data
      }
      break
    case ANALYTICAL_ACCOUNTS_NEW_ERROR:
      state = {
        ...state,
        loadingNew: false,
        errorNew: action.payload
      }
      break
    case ANALYTICAL_ACCOUNTS_EDIT:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case ANALYTICAL_ACCOUNTS_DELETE:
      state = {
        ...state,
        loadingDelete: true,
        responseDelete: "",
        errorDelete: ""
      }
      break
    case ANALYTICAL_ACCOUNTS_DELETE_SUCCESS:
      state = {
        ...state,
        loadingDelete: false,
        responseDelete: action.payload.data
      }
      break
    case ANALYTICAL_ACCOUNTS_DELETE_ERROR:
      state = {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default AnalyticalAccounts
